//--- React
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Divider, Row } from "antd";
//--- Project
import "./style.css";
import HIGHLIGHT from "assets/images/icons/PushPinSimple.png";
import { UNITS } from "components/Common/Constants";

const TripHighlight = () => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);

  const innerContent = (
    title,
    minTitle,
    minValue,
    maxTitle,
    maxValue,
    unit,
    unitClassName
  ) => {
    return (
      <Row className="border pd1 h100">
        <Col span={24} className="text-center highlight-title">
          {title}
        </Col>
        <Col span={24} className="mt1 mb025">
          <Row justify={"space-evenly"}>
            <Col>
              {minValue ? (
                <div>
                  <span className="avg-count">{minValue}</span>
                  <span className={"card-sub-text ml015 " + unitClassName}>
                    {unit}
                  </span>
                </div>
              ) : (
                <div className="disabled ml025 mb05">NA</div>
              )}
              <div className="card-sub-text text-center">{minTitle}</div>
            </Col>
            {maxTitle ? (
              <>
                <Col>
                  <Divider className="h100" type={"vertical"} />
                </Col>
                <Col>
                  {maxValue ? (
                    <div>
                      <span className="avg-count">{maxValue}</span>
                      <span className={"card-sub-text ml015 " + unitClassName}>
                        {unit}
                      </span>
                    </div>
                  ) : (
                    <div className="disabled ml025 mb05">NA</div>
                  )}
                  <div className="card-sub-text text-center">{maxTitle}</div>
                </Col>
              </>
            ) : null}
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Row gutter={[16, 10]} className="highlight">
      <Col span={24}>
        <Row gutter={[16, 16]} align={"middle"} className="mt1">
          <Col className="align-center">
            <img src={HIGHLIGHT} alt="view" height={24} />
          </Col>
          <Col className="sub-title">Highlights</Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[16, 16]} className="h100">
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Battery Current",
              "Min",
              tripSummary?.minBatteryCurrentA,
              "Max",
              tripSummary?.maxBatteryCurrentA,
              UNITS.AMPERE
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Motor Current",
              "Min",
              tripSummary?.minMotorCurrentA,
              "Max",
              tripSummary?.maxMotorCurrentA,
              UNITS.AMPERE
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Altitude",
              "Min",
              tripSummary?.minAltitude,
              "Max",
              tripSummary?.maxAltitude,
              UNITS.METER
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Lean Angle",
              "Avg",
              tripSummary?.avgLeanAngle,
              "Max",
              tripSummary?.maxLeanAngle,
              UNITS.DEGREE,
              "text-top"
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Battery Voltage",
              "Min",
              tripSummary?.minBatteryVoltage,
              "Max",
              tripSummary?.maxBatteryVoltage,
              UNITS.VOLTS
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Motor Voltage",
              "Min",
              tripSummary?.minMotorVoltage,
              "Max",
              tripSummary?.maxMotorVoltage,
              UNITS.VOLTS
            )}
          </Col>

          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Acceleration",
              "Min",
              tripSummary?.minAccelerationMps2,
              "Max",
              tripSummary?.maxAccelerationMps2,
              UNITS.METER_PER_SECONDS_SQUARED
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Turns",
              "Left",
              tripSummary?.leftTurns,
              "Right",
              tripSummary?.rightTurns
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default TripHighlight;
